import { SettingsResponse } from '../client/settings-api'

// use-settings writes the cache to localStorage (not sessionStorage)
const SETTINGS_CACHE_KEY = 'settings-cache'

export const showProgressIndicators = (): boolean => {
  try {
    const cached = localStorage.getItem(SETTINGS_CACHE_KEY)
    if (!cached) return true
    const parsed = JSON.parse(cached) as SettingsResponse
    return parsed.showProgressIndicators ?? true
  } catch {
    return true
  }
}

export default showProgressIndicators
